import { PublicProtectionProfileFilters } from "api/public/protectionProfiles/protectionProfiles.types";

export const ppFilterDefaultValues: PublicProtectionProfileFilters = {
  archived: false,
  search: "",
  tech_type: { value: "", label: "" },
  cc_version: { value: "", label: "" },
  sunset_date: { value: "", label: "" },
};
